import { render, staticRenderFns } from "./ClassRecodList.vue?vue&type=template&id=4f39c285&"
import script from "./ClassRecodList.vue?vue&type=script&lang=js&"
export * from "./ClassRecodList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports